import { render } from "./PressStatusCard.vue?vue&type=template&id=181a0f28&scoped=true"
import script from "./PressStatusCard.vue?vue&type=script&lang=js"
export * from "./PressStatusCard.vue?vue&type=script&lang=js"

import "./PressStatusCard.vue?vue&type=style&index=0&id=181a0f28&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\user\\IdeaProjects\\aipr-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-181a0f28"]])

export default __exports__